import { useCallback } from 'react';

type SupportedFormat = 'defaultDateFormat' | 'defaultDateTimeFormat' | 'defaultTimeFormat';

export const useGetDatePickerFormat = () =>
  useCallback((format: SupportedFormat) => {
    switch (format) {
      case 'defaultDateFormat':
        return 'll';
      case 'defaultDateTimeFormat':
        return 'lll';
      case 'defaultTimeFormat':
        return 'LT';
    }
  }, []);
